import { createReducer } from "store/helpers";
import { path } from "./actions";
import { EActions, ICreateMachineList, ICreateMachineState } from "./type";

const initialState: ICreateMachineState = {
  openModal: false,
  machine: null,
  devices: null,
  loading: false,
  placements: null,
  sensorTypes: null,
  loadingSensorTypes: false,
  channels: null,
  loadingChannels: false,
  audioChunkTypes: null,
  loadingAudioChunkTypes: false,
};

const reducers = {
  [EActions.setOpenModal]: ({
    payload: { openModal },
  }: ICreateMachineList) => ({
    openModal,
  }),
  [EActions.setMachine]: ({ payload: { machine } }: ICreateMachineList) => ({
    machine,
  }),
  [EActions.setDevices]: ({ payload: { devices } }: ICreateMachineList) => ({
    devices,
  }),
  [EActions.setPlacements]: ({
    payload: { placements },
  }: ICreateMachineList) => ({
    placements,
  }),
  [EActions.setLoading]: ({ payload: { loading } }: ICreateMachineList) => ({
    loading,
  }),
  [EActions.setSensorTypes]: ({
    payload: { sensorTypes },
  }: ICreateMachineList) => ({
    sensorTypes,
  }),
  [EActions.setLoadingSensorTypes]: ({
    payload: { loadingSensorTypes },
  }: ICreateMachineList) => ({
    loadingSensorTypes,
  }),
  [EActions.setChannels]: ({ payload: { channels } }: ICreateMachineList) => ({
    channels,
  }),
  [EActions.setLoadingChannels]: ({
    payload: { loadingChannels },
  }: ICreateMachineList) => ({
    loadingChannels,
  }),
  [EActions.setAudioChunkTypes]: ({
    payload: { audioChunkTypes },
  }: ICreateMachineList) => ({
    audioChunkTypes,
  }),
  [EActions.setLoadingAudioChunkTypes]: ({
    payload: { loadingAudioChunkTypes },
  }: ICreateMachineList) => ({
    loadingAudioChunkTypes,
  }),
};
export default createReducer<ICreateMachineState>(path, initialState, reducers);
